import { Popover, PopoverContent, PopoverTrigger } from '../overlay/popover';

type InfoHintProps = {
  text: string;
  className?: string;
};

export function InfoHint({ text, className }: InfoHintProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={text}
          className={[
            'relative inline-flex h-4 w-4 items-center justify-center rounded-full border border-muted-foreground/50 text-[10px] font-semibold text-muted-foreground transition-colors before:absolute before:-inset-[14px] hover:border-foreground/40 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
            className,
          ]
            .filter(Boolean)
            .join(' ')}
        >
          i
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto max-w-xs p-3 text-xs">
        {text}
      </PopoverContent>
    </Popover>
  );
}
